module.exports = __webpack_public_path__ + "img/social2.0f40c64a.jpg";